// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__18xOo","search":"Settings_search__1oacE","filter":"Settings_filter__20lnr"};